import React from 'react';
import PropTypes from 'prop-types';
import b from 'b_';
import Icon from '../../Icon/Icon';
import './TroubleshootingInstructionsContent.css';

const block = b.lock('TroubleshootingInstructionsContent');

const TroubleshootingInstructionsContent = ({ t, renderAsCards = false, CardComponent = 'div' }) => {
    const instructionData = [
        {
            header: (
                <>
                    <Icon type={'check'} className={block('CheckIcon')} />
                    {t('troubleshootingMode.instructions.header1')}
                </>
            ),
            text: t('troubleshootingMode.instructions.text1')
        },
        {
            header: (
                <>
                    <span className={block('StepNumber')}>
                        {t('troubleshootingMode.instructions.splitHeader1Step')}
                    </span>
                    {t('troubleshootingMode.instructions.splitHeader1Text')}
                </>
            ),
            text: t('troubleshootingMode.instructions.text2')
        },
        {
            header: (
                <>
                    <span className={block('StepNumber')}>
                        {t('troubleshootingMode.instructions.splitHeader2Step')}
                    </span>
                    {t('troubleshootingMode.instructions.splitHeader2Text')}
                </>
            ),
            text: t('troubleshootingMode.instructions.text3')
        }
    ];

    const renderInstruction = (instruction, index) => {
        const headerElement = (
            <h3 className={block('InstructionHeader')}>
                {instruction.header}
            </h3>
        );

        const textElement = (
            <p className={block('InstructionText')}>
                {instruction.text}
            </p>
        );

        if (renderAsCards) {
            return (
                <CardComponent
                    key={index}
                    className={block('InstructionCard')}
                >
                    <div className={block('CardHeader')}>
                        {headerElement}
                    </div>
                    <div className={block('CardContent')}>
                        {textElement}
                    </div>
                </CardComponent>
            );
        }

        return (
            <React.Fragment key={index}>
                {headerElement}
                {textElement}
            </React.Fragment>
        );
    };

    return instructionData.map(renderInstruction);
};

TroubleshootingInstructionsContent.propTypes = {
    t: PropTypes.func.isRequired,
    renderAsCards: PropTypes.bool,
    CardComponent: PropTypes.elementType,
};

export default TroubleshootingInstructionsContent;
